export { default } from './TableText';
